// components/FilialeView.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import JobList from './JobList';
import CandidatesList from './CandidatesList';

function FilialeView({ role }) {
  const { filialeName } = useParams();

  return (
    <>
      <h4 className="mb-4">Vue de la filiale : {filialeName}</h4>
      <JobList role={role} filiale={filialeName} />
      <CandidatesList role={role} filiale={filialeName} />
    </>
  );
}

export default FilialeView;
